import { ReactNode, useEffect, useMemo, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";

const nigerianGreetings = [
  "Welcome",
  "E kaabo",
  "Barka da zuwa",
  "Nnoo",
  "Ndewo",
  "Medaase",
  "Sannu da zuwa",
];

interface DashboardOverviewHeaderProps {
  title: string;
  subtitle: string;
  actions?: ReactNode;
}

export function DashboardOverviewHeader({
  title,
  subtitle,
  actions,
}: DashboardOverviewHeaderProps) {
  const { profile } = useAuth();
  const [greetingIndex, setGreetingIndex] = useState(0);

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    const interval = window.setInterval(() => {
      setGreetingIndex((current) => (current + 1) % nigerianGreetings.length);
    }, 2600);

    return () => window.clearInterval(interval);
  }, []);

  const fullName = useMemo(() => {
    const value = `${profile?.first_name || ""} ${profile?.last_name || ""}`.trim();
    return value || "there";
  }, [profile?.first_name, profile?.last_name]);

  const greeting = `${nigerianGreetings[greetingIndex]}, ${fullName}`;

  return (
    <div className="flex flex-col gap-4 rounded-[2rem] border border-border bg-card/80 p-5 shadow-sm sm:p-6 lg:flex-row lg:items-start lg:justify-between">
      <div className="space-y-2">
        <div className="min-h-[2rem] text-lg font-semibold text-primary sm:text-xl">
          {greeting}
        </div>
        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-foreground sm:text-3xl">{title}</h1>
          <p className="max-w-2xl text-sm leading-6 text-muted-foreground sm:text-base">
            {subtitle}
          </p>
        </div>
      </div>

      {actions ? <div className="flex flex-wrap gap-2 lg:justify-end">{actions}</div> : null}
    </div>
  );
}
